import type { ChatActivityIcon } from '@wundo/shared/chat.ts';
import { m } from '@/paraglide/messages.js';

/** What an opened item of a step is called, and the words of the link to its page. */
export function chatActivityItemLabels(icon: ChatActivityIcon | undefined): {
  kind: string;
  open: string;
} {
  switch (icon) {
    case 'memory':
      return { kind: m.chat_activity_kind_memory(), open: m.chat_activity_open() };
    case 'search':
      return { kind: m.chat_activity_kind_document(), open: m.chat_activity_open() };
    case 'document':
      return { kind: m.chat_activity_kind_prep(), open: m.chat_activity_open_prep() };
    case 'reminder':
      return { kind: m.chat_activity_kind_reminder(), open: m.chat_activity_open() };
    case 'page':
      return { kind: m.chat_activity_kind_page(), open: m.chat_activity_open_page() };
    default:
      return { kind: m.chat_activity_kind_other(), open: m.chat_activity_open() };
  }
}
